import { api } from './api';
import type { Automation, AutomationListItem, StageOptionsResponse } from '../types/automations';

interface PaginatedResponse<T> {
  count: number;
  results: T[];
  next?: string | null;
  previous?: string | null;
}

export const AutomationsAPI = {
  async list(page?: number): Promise<PaginatedResponse<AutomationListItem>> {
    const url = page && page > 1
      ? `/api/automations/automations/?page=${page}`
      : '/api/automations/automations/';
    const res = await api.get<AutomationListItem[] | PaginatedResponse<AutomationListItem>>(url);
    if (Array.isArray(res.data)) {
      return { count: res.data.length, results: res.data, next: null, previous: null };
    } else if (res.data && 'results' in res.data) {
      return res.data as PaginatedResponse<AutomationListItem>;
    }
    return { count: 0, results: [], next: null, previous: null };
  },
  async retrieve(id: number): Promise<Automation> {
    const res = await api.get<Automation>(`/api/automations/automations/${id}/`);
    return res.data;
  },
  async create(payload: Partial<Automation>): Promise<Automation> {
    const res = await api.post<Automation>('/api/automations/automations/', payload);
    if (!res.data) {
      throw new Error('No data returned from create automation API');
    }
    return res.data;
  },
  async update(id: number, payload: Partial<Automation>): Promise<Automation> {
    const res = await api.patch<Automation>(`/api/automations/automations/${id}/`, payload);
    return res.data;
  },
  async destroy(id: number): Promise<void> {
    await api.delete(`/api/automations/automations/${id}/`);
  },
  async testRun(id: number, body: any): Promise<any> {
    const res = await api.post<any>(`/api/automations/automations/${id}/test-run/`, body);
    return res.data;
  },
  async getStageOptions(): Promise<StageOptionsResponse> {
    const res = await api.get<StageOptionsResponse>('/api/automations/automations/stage-options/');
    return res.data;
  },
};





